import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { TerminalState } from "./model";

let state: TerminalState = {
  terminals: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<TerminalState, RootStateType>;
